<template>
  <el-row class="app-container text-left">
    <el-dialog :visible.sync="dialogFormVisible" ref="dlg" custom-class="dialog-large" width="600px" :show-close="false"
      :close-on-click-modal="false" :append-to-body="true" @opened="GetPreData">
      <el-row slot="title">
        <el-col :span="12">
          <span style="font-size: 18px">代约面试设置</span>
        </el-col>
        <el-col :span="12" class="text-right">
          <a @click="onHelpClick">
            <div class="el-icon-warning">代约帮助</div>
          </a>
          <button type="button" aria-label="Close" class="el-dialog__headerbtn" style="position:static;margin-left:10px;" @click="dialogFormVisible=false">
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
        </el-col>
      </el-row>

      <div style="padding-bottom: 10px; border-bottom: 1px solid #DCDFE6">
        <span>已选中人才：</span>
        <user-avatar :src="headImg" className="useravatar-cirle-sm"></user-avatar>
        <span>{{ name }}</span>
      </div>
      <el-form :rules="rules" size="small" ref="dataForm" :model="data" style="margin-top: 10px;">
        <el-form-item label="面试职位：" prop="CoPostID">
          <el-select v-model="data.CoPostID" placeholder="请选择" @change="onPostChange">
            <el-option v-for="item in postList" :key="item.post_id" :label="item.post_name" :value="item.post_id">
            </el-option>
          </el-select>
          <span v-if="iiCnt > 0" style="margin-left: 20px; color: rgb(168, 168, 168)">本职位已提交代约{{iiCnt}}个</span>
          <span v-else style="margin-left: 20px; color: rgb(168, 168, 168)">本职位还未提交邀约</span>
        </el-form-item>
        <el-form-item label="月薪范围：" prop="Salary">
          <el-col :span="6">
            <el-form-item prop="MinSalary">
              <el-input v-model="data.MinSalary" placeholder="1-999">
                <template slot="append">K</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="1">-</el-col>
          <el-col :span="6">
            <el-form-item prop="MaxSalary">
              <el-input v-model="data.MaxSalary" placeholder="1-999">
                <template slot="append">K</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="岗位职责：" prop="PostDescription">
          <el-input v-model="data.PostDescription" type="textarea" rows="4"></el-input>
        </el-form-item>
        <el-form-item label="面试地点：" prop="InterviewAddress">
          <el-input v-model="data.InterviewAddress" type="textarea" rows="2"></el-input>
        </el-form-item>
        <el-form-item label="邀约要点：" prop="Notice">
          <el-input v-model="data.Notice" type="textarea" rows="2"
          placeholder="请输入顾问邀约时的注意事项"></el-input>
        </el-form-item>
        <el-form-item label="面试时间建议：" prop="InterviewTimeSuggest">
          <el-input v-model="data.InterviewTimeSuggest" type="textarea" rows="2"
            placeholder="比如：工作日上午10点 - 12点，下午2点 - 4点"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button size="middle" @click="onCancel">取 消</el-button>
          <el-button size="middle" type="primary" @click="onSave">确定代约</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogHelpVisible" custom-class="dialog-large" title="代约帮助" width="480px" :append-to-body="true">
      <ul class="sort-list">
        <li>申请代约后会有乐跳顾问帮您联系人才。</li>
        <li>人才如有意向，顾问会联系您约定面试时间。</li>
        <li>您也可以在：人才圈 - 我的代约，查看代约的最新反馈。</li>
        <li>转面试后扣除“帮我约到面数”</li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCancelHelp">取消</el-button>
        <el-button type="primary" @click="onConfirmHelp">继续代约</el-button>
      </div>
    </el-dialog>
  </el-row>
</template>

<script>
  import userAvatar from '~/components/UserAvatar';
  import inputNumRang from '~/components/input_number_range';
  import {
    parseTime,
    getInsteadInviteState
  } from '~/utils';
  import {
    getOnPostList,
    getLastInsteadInvite,
    saveInsteadInvite,
    saveTalentToMeLibrary, //转存
    updateInsteadInviteMedataID, //更新转存后代约的MeDataID
    getInsteadInviteByTalentPost,
  } from '~/api/insteadInvite';
  export default {
    props: {
    },
    components: {
      userAvatar,
      inputNumRang,
    },
    data() {
      const checkSalary = (r, val, callback) => {
        var mins = this.data.MinSalary;
        var maxs = this.data.MaxSalary;
        if (isNaN(mins) || mins <= 0) {
          callback(new Error('最小薪资必须为正整数'));
          return;
        } else if (isNaN(maxs) || maxs <= 0) {
          callback(new Error('最大薪资必须为正整数'));
          return;
        } else if (mins > maxs) {
          callback(new Error('最小薪资不能大于最大薪资'));
          return;
        } else callback();
      };
      return {
        dialogFormVisible: false,
        dialogHelpVisible: false,
        name: '',
        headImg: '',
        haveInsteadInvite: null,

        postList: [], //人事默认公司下的职位
        iiCnt: 0, //当前职位的已代约职位个数
        data: {
          //代约数据
          HrInsteadInviteID: 0, //自动
          InsteadInviteState: 1, //默认为有效
          HrDataID: 0,
          ResumeSource: 0, //打开对话框时设置
          ResumeID: 0, //打开对话框时设置
          CoPostID: 0,
          PostName: '',
          MinSalary: 0,
          MaxSalary: 0,
          PostDescription: '',
          InterviewAddress: '',
          Notice: '',
          InterviewTimeSuggest: '',
          RegDateTime: '1900-01-01', //后端取
          IsProcessed: 0, //默认未处理
          IsContact: 0, //默认未联系上
          MeDataID: 0, //顾问约上面试后填写
          LoInterviewID: 0, //顾问约上面试后填写
        },
        rules: {
          CoPostID: {
            required: true,
            trigger: 'change',
            message: '请选择',
          },
          Salary: {
            required: true,
            validator: checkSalary,
            // trigger: 'change'
          },
          PostDescription: {
            required: true,
            trigger: 'change',
            message: '请填写',
          },
          InterviewAddress: {
            required: true,
            trigger: 'change',
            message: '请填写',
          },
          Notice: {
            required: true,
            trigger: 'change',
            message: '请填写',
          },
          InterviewTimeSuggest: {
            required: true,
            trigger: 'change',
            message: '请填写',
          },
        },
      };
    },
    filters: {
      _ParseTime(time, cformat) {
        var date = new Date(time);
        return parseTime(date, cformat);
      },
    },
    methods: {
      show(talent) {
        this.name = talent.fullName;
        this.headImg = talent.headImage;
        this.data.ResumeSource = talent.resumeSource;
        this.data.ResumeID = talent.resumeId;
        this.dialogHelpVisible = true;
      },
      //-------------------------------------------------------------------------------
      onHelpClick() {
        this.dialogHelpVisible = true;
      },

      onCancel() {
        this.dialogFormVisible = false;
      },
      onSave() {
        let THIS = this;
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            if (THIS.haveInsteadInvite != null) {
              THIS.CheckPost();
              return;
            }

            THIS.$confirm(
              `将请顾问代约人才『${THIS.name}』来面试『${THIS.data.PostName}』职位，是否继续？`,
              '代约确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning',
              }
            )
              .then(() => {
                saveInsteadInvite(THIS.data).then((r) => {
                  if (r.errcode === 0) {
                    THIS.onCancel();
                    THIS.$message.success('对该人才的发起代约成功');
                    THIS.$emit('success');
                    THIS.AddOne(THIS.data.CoPostID); //代约人数加1
                    saveTalentToMeLibrary({
                      source: THIS.data.ResumeSource,
                      id: THIS.data.ResumeID
                    }).then(res => {
                      if (res.errcode == 0) {
                        updateInsteadInviteMedataID({
                          instead_invite_id: r.data,
                          me_id: res.data
                        }).then(response => {
                          if (response.errcode != 0) this.$message.error('更新代约信息出错');
                        });
                      } else {
                        this.$message.error('转存入核心库出错，原因：' + res.errmsg);
                      }
                    });
                  } else {
                    THIS.$message.error('保存失败，原因：' + r.errmsg);
                  }
                });
              })
              .catch(() => {});
          }
        });
      },
      onPostChange() {
        this.$refs['dataForm'].clearValidate();
        let post = this.postList.filter((x) => x.post_id == this.data.CoPostID);
        this.SetData(post[0], 2);
      },
      //-------------------------------------------------------------------------------
      AddOne(postId) {
        let post = this.postList.filter((x) => x.post_id == postId);
        post[0].insteadInview_count++;
        this.iiCnt = post[0].insteadInview_count; //最近代约里缺已代约人数
      },
      CheckPost() {
        let THIS = this;
        THIS.$alert(
          `该人才已有该职位的代约设置，设置时间：${parseTime(
            THIS.haveInsteadInvite.RegDateTime,
            '{y}-{m}-{d} {h}:{i}'
          )}，状态：${THIS._GetResult()}。<br><span style='color:rgb(185, 93, 60);'>请更换职位后再试。</span>`,
          '重复代约提示', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
            type: 'warning',
          }
        );
      },
      GetPreData() {
        getOnPostList().then((r) => {
          if (r.errcode == 0) {
            this.postList = r.data;
            if (this.postList.length == 0) {
              this.$message.error('您目前还没有有效职位，请到职位管理发布职位');
              this.onCancel();
              return;
            }

            getLastInsteadInvite().then((r) => {
              if (r.errcode == 0) {
                if (r.data == null) {
                  this.SetData(this.postList[0], 2); //指定职位
                } else {
                  this.SetData(r.data, 1); //最近代约
                }
                // this.dialogHelpVisible = true;
              } else {
                this.$message.error('获取最近代约信息出错，原因：' + r.errmsg);
              }
            });
          } else {
            this.$message.error('获取职位列表出错，原因：' + r.errmsg);
          }
        });
      },
      GetTalentPostInsteadInvite() {
        let tpData = {
          resume_source: this.data.ResumeSource,
          resume_id: this.data.ResumeID,
          post_id: this.data.CoPostID,
        };
        getInsteadInviteByTalentPost(tpData).then((r) => {
          if (r.errcode == 0) {
            this.haveInsteadInvite = r.data;
            if (r.data != null) this.CheckPost();
          } else {
            this.$message.error(
              '获取人才该职位已有有效代约失败，原因：' + r.errmsg
            );
          }
        });
      },
      SetData(dt, flag) {
        if (flag == 1) {
          //用最近代约填充this.data
          let post = this.postList.filter((x) => x.post_id == dt.CoPostID);
          this.data.HrDataID = dt.HrDataID;
          this.data.CoPostID = dt.CoPostID;
          this.data.PostName = post[0].post_name; //最近代约里缺职位名称
          this.data.MinSalary = dt.MinSalary;
          this.data.MaxSalary = dt.MaxSalary;
          this.data.PostDescription = dt.PostDescription;
          this.data.InterviewAddress = dt.InterviewAddress;
          this.data.Notice = dt.Notice;
          this.data.InterviewTimeSuggest = dt.InterviewTimeSuggest;
          this.iiCnt = post[0].insteadInview_count; //最近代约里缺已代约人数
        } else {
          //用指定职位填充this.data
          this.data.HrDataID = dt.hr_id;
          this.data.CoPostID = dt.post_id;
          this.data.PostName = dt.post_name;
          this.data.MinSalary = dt.min_salary;
          this.data.MaxSalary = dt.max_salary;
          this.data.PostDescription = dt.post_description;
          this.data.InterviewAddress = dt.address;
          this.data.Notice = '';
          this.data.InterviewTimeSuggest = '';
          this.iiCnt = dt.insteadInview_count;
        }
        this.GetTalentPostInsteadInvite();
      },
      //-------------------------------------------------------------------------------
      _GetResult() {
        let hii = this.haveInsteadInvite;
        return getInsteadInviteState(
          hii.IsProcessed,
          hii.IsContact,
          hii.LoInterviewID
        );
      },
      onCancelHelp(){
        this.dialogHelpVisible = false;
      },
      onConfirmHelp(){
        this.dialogHelpVisible = false;
        if(!this.dialogFormVisible){
          this.dialogFormVisible = true;
        }
      }
    },
  };
</script>
<style lang="scss" scoped>
  .line {
    text-align: center; //color:rgb(185, 93, 60)
  }
</style>